/**
 * Copy for the manual site-access refresh, shared by the RCRAInfo Credentials
 * and RCRAInfo Site Access tabs. Both buttons queue the same job, so the
 * guidance — it runs on a schedule, only trigger it if you just changed
 * something in RCRAInfo — has to say the same thing in both places.
 */
export const SITE_ACCESS_REFRESH_TOOLTIP =
  "EPA ID mappings are automatically managed by the site access job. Click to manually " +
  "trigger a refresh. Note that this job runs on a schedule and reads directly from " +
  "RCRAInfo via the API to determine site access. Only trigger a refresh if you've made " +
  "a change in RCRAInfo and want to see it reflected here immediately.";
